import React, { useContext } from "react";
import styled, { keyframes } from "styled-components";
import { WidgetContext } from "../WidgetContext";
import Close from "./Close";
import tecobiIcon from "../assets/tecobi-icon.png";

const CloseButton = styled(Close)`
  cursor: pointer;
  position: absolute;
  height: 26px;
  top: 5px;
  right: 5px;
  width: 26px;
`;

const slideOut = keyframes`
from {right: 0;}
to {right: -200px;}
`;

export default styled((props) => {
  const { state, dispatch } = useContext(WidgetContext);
  const { smswidgetconfig: widgetConfig } = state.config;

  return (
    <header
      style={{
        backgroundColor: widgetConfig.background_color,
        color: widgetConfig.text_color,
        height: "20px",
        justifyContent: 'center',
        alignItems: 'center'
      }}
      {...props}
    >

      <img
        className="logo"
        src={widgetConfig.logo ? widgetConfig.logo : tecobiIcon}
        alt={`${state.config.name} logo`}
      />
      {/* <p>
        Welcome to {state.config.name}! Send us a text using the form below.
      </p> */}
      <CloseButton
        color={widgetConfig.text_color}
        onClick={() => dispatch({ type: "set", value: { isPopupOpen: false } })}
      />
      <div
        style={{
          // height: "50px",
          width: "80%",
          borderRadius: "20px",
          backgroundColor: "white",
          border: "1px solid white",
          maxHeight: "110px",
          overflow: "auto",
          boxShadow: "0 0 5px rgba(0, 0, 0, 0.3)",
          alignSelf: 'center',
          position: 'absolute',
          top: '70px',
          // right: '15px',
          padding: '10px',
          display: 'flex',
          left: '50%',
          transform: 'translateX(-50%)',
          justifyContent: 'flex-start'
        }}
      >
        <p style={{ color: "#605F5F" }}>
        {widgetConfig.welcome_text}
        </p>
      </div>
    </header>
  );
})`
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  padding: 15px 20px 100px;

  .logo {
    object-fit: contain;
    height: auto;
    max-height: 40px;
    width: 100%;
  }

  p {
    text-align: center;
    font-size: 12px;
    font-family: 'Fira Sans', sans-serif;
  }

  &.close {
    animation: ${slideOut} 0.6s ease forwards;
  }
`;
